import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { ease } from "../lib/content";

export const introState = { pending: window.location.pathname === "/" };

export const Intro = () => {
  const [show, setShow] = useState(introState.pending);

  useEffect(() => {
    if (!show) return undefined;
    const t = setTimeout(() => {
      setShow(false);
      introState.pending = false;
    }, 3000);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-curtain"
          className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center bg-teal text-mist"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease }}
        >
          <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 1.08, opacity: 0 }} transition={{ duration: 1.2, ease }}>
            <LogoMark draw className="h-44 w-44 sm:h-64 sm:w-64" strokeWidth={3} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
